import { render, staticRenderFns } from "./left.vue?vue&type=template&id=b260f184"
import script from "./left.vue?vue&type=script&lang=js"
export * from "./left.vue?vue&type=script&lang=js"
import style0 from "./left.vue?vue&type=style&index=0&id=b260f184&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports